import ChipsBox from './ChipsBox';

export default ChipsBox;
